import { render } from "./Indicator.vue?vue&type=template&id=d5710df6&scoped=true"
import script from "./Indicator.vue?vue&type=script&lang=js"
export * from "./Indicator.vue?vue&type=script&lang=js"

import "./Indicator.vue?vue&type=style&index=0&id=d5710df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5710df6"]])

export default __exports__